import { Component, h } from 'preact'
import TopicLabel from '../topic-list-view/TopicLabel'
import ClampLines from 'react-clamp-lines'
import ProductUpdateDateFormatter from './ProductUpdateDateFormatter'
// import TopicListLikeButton from '../topic-list-view/TopicListLikeButton'
// import TopicComments from '../topic-list-view/TopicComments'
// import TopicLastPost from '../topic-list-view/TopicLastPost'
import { ProductUpdateType } from './Types'
import htmlParser from '../utils/htmlParser'
import Phrase from '../../libs/translationsUtils/phrase'
import TopicViewsCount from '../../control-components/ui-components/TopicViewsCount'
import TopicLike from '../topic-list-view/TopicLike'
import Axios from 'axios'
import { LikedUserType } from '../topic-list-view/LikedUsers'
import TopicComments from '../topic-list-view/TopicComments'
import TopicLastPost from '../topic-list-view/TopicLastPost'
import topicUrlGenerator from '../utils/topicUrlGenerator'
import { common } from '../common'

interface Person {
  id: string
  avatar: string
  username: string
  reputation: {
    repliesMade: number
  }
}

interface Props extends ProductUpdateType {
  isGuest: boolean
  key: string
  id: string
  productAreasMapping: {
    [key: string]: string
  }
  currentUser?: LikedUserType
  likeSet: string[]
  replyCount: number
  lastPostId: number
  lastContributor: Person
  lastActivityAt: string
}

interface State {
  isCurrentUserLiked: boolean
  likedUsers: {
    [key: string]: LikedUserType
  }
}

class ProductUpdateView extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      likedUsers: {},
      isCurrentUserLiked: !!this.props.currentUser && this.props.currentUser.id !== null && this.props.likeSet.includes(this.props.currentUser.id.toString())
    }
    this.handleLikeStatusToggle = this.handleLikeStatusToggle.bind(this)
  }

  async handleLikeStatusToggle (e: MouseEvent) {
    e.preventDefault()
    e.stopPropagation()
    if (!this.props.currentUser) return

    if (this.props.currentUser.id === null) {
      const event = new CustomEvent('GuestUserAction')
      window.dispatchEvent(event)
      return
    }

    if (this.state.isCurrentUserLiked) {
      delete this.state.likedUsers[this.props.currentUser.id]
      this.setState({ likedUsers: this.state.likedUsers, isCurrentUserLiked: false })
      await Axios.post(`/community/api/productUpdates/${this.props.id}/unlike`, {
        unlikedBy: this.props.currentUser.id
      })
    } else {
      this.setState({ likedUsers: { ...this.state.likedUsers, [this.props.currentUser.id]: this.props.currentUser }, isCurrentUserLiked: true })
      await Axios.post(`/community/api/productUpdates/${this.props.id}/like`, {
        likedBy: this.props.currentUser.id
      })
    }
  }

  async componentDidMount () {
    if (this.props.likeSet.length) {
      const res = await Axios.post('/member/getUsersById', {
        ids: this.props.likeSet
      })

      this.setState({ likedUsers: res.data })
    }
  }

  render ({
    id, title, content, publicLabel, publishedAt, contentType, views, featuredImage,
    productAreas, productAreasMapping, replyCount, lastContributor, lastPostId, lastActivityAt
  }: Props, { isCurrentUserLiked, likedUsers }: State) {
    const strippedContent = htmlParser.stripHtml(content)
    const productUpdateUrl = `/product-updates/${id}`
    const totalLikes = Object.keys(likedUsers).length
    const lastPostUrl = lastPostId ? topicUrlGenerator('product-updates', title, id, null, lastPostId.toString()) : productUpdateUrl
    const relativeDate = common.relativeDate(new Date(lastActivityAt).getTime())

    return (
      <article className='product-update-view card-widget-wrapper'>
        <a href={productUpdateUrl} className='product-update-url' aria-label={title}>
          {
            featuredImage ? <img className='product-update-view_feature-image' src={featuredImage} /> : null
          }
          <div className='product-update-view_info'>
            <div className='product-update-view_info--metadata'>
              <TopicLabel topic={{ contentType: contentType, publicLabel: publicLabel }} />
              <span className='text--meta'> {ProductUpdateDateFormatter(publishedAt)} </span>
            </div>
            <h4 className='card-widget-title product-update-view_info-title h3'>
              {title}
            </h4>
            <ClampLines
              id='product-update-view'
              className='card-widget-text product-update-view_info-content'
              innerElement='p'
              lines={4}
              text={strippedContent || ''}
              buttons={false}
            />
            {
              productAreas.length
                ? (
                  <div className='product-update-view_product-areas'>
                    <span className='text--meta'>
                      <Phrase p='product.areas.related.products' />:
                    </span>
                    {
                      productAreas.map(productAreaId => <span key={productAreaId} className='text--dot-underline product-area-item'>
                        {productAreasMapping[productAreaId]}
                      </span>)
                    }
                  </div>
                  )
                : null
            }
            <div className='topic-view_footer'>
              <ul className='topic-view_footer-items'>
                <TopicLike
                  className={`${isCurrentUserLiked ? 'active' : ''}`}
                  onClick={this.handleLikeStatusToggle}
                  displayLikeCount
                  likeCount={totalLikes}
                />
                <li className='thread-meta-item thread-meta-item--hover-highlight is-hidden-S'>
                  <a className='qa-topic-meta-views' href={productUpdateUrl}>
                    <TopicViewsCount views={views} />
                  </a>
                </li>
                <li className='thread-meta-item'>
                  <TopicComments
                    numberOfReplies={replyCount}
                    id={id}
                    lastPostUrl={lastPostUrl}
                  />
                </li>
                <li className='thread-meta-item'>
                  <TopicLastPost
                    lastPostAuthor={{ ...lastContributor, name: lastContributor.username }}
                    lastPostUrl={lastPostUrl}
                    lastPostRelativeCreationDate={relativeDate}
                  />
                </li>
              </ul>
            </div>
          </div>
        </a>
      </article>
    )
  }
}

export default ProductUpdateView
